const berkACBlackCensus = [
  {
    year: '1950',
    Berkeley: 13289,
    'Alameda County': 69442,
  },
  {
    year: '1960',
    Berkeley: 21850,
    'Alameda County': 111420,
  },
  {
    year: '1970',
    Berkeley: 27421,
    'Alameda County': 161282,
  },
  {
    year: '1980',
    Berkeley: 20671,
    'Alameda County': 203698,
  },
  {
    year: '1990',
    Berkeley: 19309,
    'Alameda County': 229316,
  },
  {
    year: '2000',
    Berkeley: 14007,
    'Alameda County': 215598,
  },
  {
    year: '2010',
    Berkeley: 11241,
    'Alameda County': 190451,
  },
  {
    year: '2020',
    Berkeley: 9812,
    'Alameda County': 185059,
  },
];

export default berkACBlackCensus;
